import { gql } from "@apollo/client";

export const RETRIEVE_BOOKINGS = gql`
    query gqlRetrieveBooksByRestaurant($nIDRestaurant: Int!) {
        data: gqlRetrieveBooksByRestaurant(nIDRestaurant: $nIDRestaurant) {
            nID
            dDate
            nGuests
            nIDRestaurant
            nIDTimeSlot
            sAccessNeeds
            sChildrenNeeds
            sDescription
            sName
            sPhone
            sSetting
            sTime
            bMenu
            nIDMenu
            nStatus
        }
    }
`;

export const RETRIEVE_BOOK_KPIS = gql`
    query gqlRetrieveKPIs($dDate: String, $nIDRestaurant: Int) {
        data: gqlRetrieveKPIs(dDate: $dDate, nIDRestaurant: $nIDRestaurant) {
            tStart
            tEnd
            nStatus
            nGuests
        }
    }
`;

export const RETRIEVE_ALL_BOOKINGS = gql`
    query gqlRetrieveAllReservationsByRestaurant($nIDRestaurant: Int!) {
        data: gqlRetrieveAllReservationsByRestaurant(nIDRestaurant: $nIDRestaurant) {
            nID
            dDate
            nGuests
            nIDRestaurant
            nIDTimeSlot
            sAccessNeeds
            sChildrenNeeds
            sDescription
            sName
            sPhone
            sSetting
            sTime
            bMenu
            nIDMenu
            nStatus
            nStatusHistory
            dDateHistory
            sUser
        }
    }

`;